<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light">

                <div class="row mb-2">
                    <h1 class="col-md-12 text-center">Franchises</h1>
                </div>

                <div class="row  mt-2">

                    <div class="col-md-2 " v-if="authenticatedUser.permissions.includes('super') ">
                        <b-link class="" :to="{ path: '/franchise-detail-form',query: { type: 'add'} }">
                            <b-button class="btn-info mb-2" > Add Franchise </b-button>
                        </b-link>
                    </div>

                    <div class="col-md-2" v-if="authenticatedUser.permissions.includes('super')">
                        <b-input v-model="searchName"
                                 @input="debouncedSearch"
                                 placeholder="Search by Name"></b-input>
                    </div>

                </div>
                <div class="row mt-2" >
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-2">

                    </div>
                    <div class="col-md-1">
                        <button class="btn-sm btn-info"     :disabled="franchisees?.current_page==1" @click="get_paged_data('prev')">Previous</button>
                    </div>
                    <div class="col-md-3">
                        <span class="text-light mx-2 px-2" v-if="!showloader" style="border: 3px solid white; border-radius: 5px"> showing  ( <span v-if="franchisees?.to-50>0">{{franchisees?.to-50}}</span> <span v-else="">0</span>  to {{franchisees.to}}) out of {{franchisees.total}} records</span>
                    </div>
                    <div class="col-md-1">

                        <button class="btn-sm btn-info "    :disabled="franchisees?.current_page==totalPages" @click="get_paged_data('next')">Next</button>
                    </div>
                    <div class="col-md-2 ">

                    </div>

                </div>
                <div class="row mt-1">
                    <div v-if="showloader" class="col-md-10 offset-1 text-center">
                        <loader/>
                    </div>
                </div>
                <div class="row mt-2">
                 <div class="col-md-12">
                     <table class="table table-bordered table-striped text-light">
                         <thead class="thead-dark">
                         <tr>

                             <th>ID</th>
                             <th>Name</th>
                             <th>Legal Company Name</th>
                             <th>Branch Name (Invoice)</th>
                             <th>Royalties %</th>
                             <th>Cost Margin %</th>
                             <th>Shipping Margin %</th>
                             <th>Collection Fix Rate</th>
                             <th>Due Days</th>
                             <th>Status</th>
                             <th>Email</th>
                             <th>Tel</th>
                             <th class="text-center">Actions</th>
                         </tr>
                         </thead>
                         <tbody >
                         <template v-for="franchisee in franchisees.data">
                             <tr>
                                 <td>{{franchisee.id}}</td>
                                 <td>{{franchisee.f_name}}</td>
                                 <td>{{franchisee.f_legalCompanyName}}</td>
                                 <td>{{franchisee.f_branchNameInvoice}}</td>
                                 <td>{{franchisee.f_royalities_percentage}}</td>
                                 <td>{{franchisee.f_costMarginPercent}}</td>
                                 <td>{{franchisee.f_shippingMarginPercent}}</td>
                                 <td>{{franchisee.f_collectionFixRate}}</td>
                                 <td>{{franchisee.f_dueDays}}</td>
                                 <td>{{franchisee.status}}</td>
                                 <td>{{franchisee.email}}</td>
                                 <td>{{franchisee.tel}}</td>
                                 <td class="text-center">
                                     <b-link class="mx-1" :to="{ path: '/franchise-detail-form',query: { type: 'edit', 'id': franchisee.id } }">
                                         <b-button class="btn-info  mb-1" > Edit </b-button>
                                     </b-link>
                                     <!--                                    <b-button @click="deleteFranchisee(franchisee.id)" :disabled="saving" class="btn-danger "> Delete </b-button>-->
                                 </td>
                             </tr>
                         </template>

                         </tbody>
                     </table>
                 </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import URL from "@/constants/baseurl";
import Loader from "@/components/loader.vue";
import Swal from "sweetalert2";
import axios from "axios";
import {cloneDeep} from "lodash";
import debounce from "lodash/debounce";


export default {
    name: "franchise management",

    components:{Loader, Welcomenote, 'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),

        ...mapState('franchisees',['franchisee_filters','franchisees']),
        totalPages() {
            const perpage = this.franchisees.per_page;
            const total=this.franchisees.total;

            return Math.ceil(total / perpage);
        },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },


    },
    data() {
        return {
            saving:false,
            showloader:false,
            searchName:'',
        };
    },
    async created() {
        this.searchName = this.franchisee_filters.name;
        this.showloader=true
        await this.get_franchisees();
        this.showloader=false

    },
    async mounted() {

    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('franchisees', ['set_franchisees','get_franchisees']),

        debouncedSearch: debounce(function () {
            this.franchisee_filters.name = this.searchName;
            this.franchisee_filters.page = 1;
            this.showloader = true;
            this.get_franchisees().finally(() => {
                this.showloader = false;
            });
        }, 500),

        async deleteFranchisee(id){

            const result = await Swal.fire({
                title: 'Are you sure you want to delete this franchise?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            });
            if (result.isConfirmed) {

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }
                try {
                    this.saving=true
                    const res = await axios.delete(`${URL.BASEURL}/api/delete-franchisee/${id}`);

                    if (res) {
                        let franchisees=cloneDeep(this.franchisees)
                        franchisees.data=this.franchisees.data.filter((c)=>c.id!==id)
                        await this.set_franchisees(franchisees)

                        Swal.fire('success', 'Franchise Deleted', 'success');

                    } else {
                        Swal.fire('info', 'Franchise Cannot Be Deleted', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to delete franchise.', 'info');
                }
                this.saving=false
            }

        },

        async signOut() {
            await this.processLogoutManual();
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },

        async get_paged_data(button){
            let current_page= this.franchisees.current_page
            this.franchisee_filters.page=current_page

            if(button=='next'){
                this.franchisee_filters.page=current_page+1
                await this.get_franchisees()
            }
            if(button=='prev'){
                this.franchisee_filters.page=current_page-1
                await this.get_franchisees()
            }
        },

    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}

</style>
